<template>
	<div class="orderdetail">
		<cube-page type="orderdetail-view" title="订单详情">
			<div slot="content">
        <div class="orderitem">
          <div class="ordertitle">
            <p>订单号：{{order.order_no}}</p>
            <p class="colorred">{{order.order_status_text}}</p>
          </div>
          <div class="ordemain">
            <div class="ordecontent">
              <div class="order">
                <van-image radius="8" width="88" height="90" :src="order.image" />
                <div class="orderright">
                  <p class="ordername ells">{{order.goods_name}}</p>
                  <div class="carddesc">
                    <span>使用时间：</span>
                    <span>{{order.use_date}}</span>
                  </div>
                  <div class="carddesc">
                    <span>支付金额：</span>
                    <span>{{order.pay_price}}</span>
                  </div>
                  <div class="carddesc">
                    <span>下单时间：</span>
                    <span>{{order.createtime}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="orderfooter">
              <p class="ordernum"><span>下单数量：</span>{{order.total_num}}</p>
              <div class="orderjj">
              </div>
            </div>
          </div>
        </div>
        <van-collapse v-model="activeNames">
          <van-collapse-item title="备注信息">
            <div class="itembox">
              <div class="itemright">
                <div class="itemxx" v-if="order.code_hide">
                  <span style="color: red">{{order.code_hide_msg}}</span>
                </div>
                <div class="itemxx" v-if="remarks.user">
                  用户备注：
                  <span>{{remarks.user}}</span>
                </div>
                <div class="itemxx" v-if="remarks.dtb">
                  分销商备注：
                  <span>{{remarks.dtb}}</span>
                </div>
                <div class="itemxx" v-if="remarks.refusal">
                  拒单备注：
                  <span>{{remarks.refusal}}</span>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div  v-for="(goods,index) in list" :key="index">
            <van-collapse-item :title="goods.goods_attr" >
              <div class="itembox" v-for="(item,index) in goods.meta" :key="index">
                <div class="itemright">
                  <div class="itemxx">
                    联系人：
                    <span>{{item.contacts}}</span>
                  </div>
                  <div class="itemxx">
                    联系电话：
                    <span class="phpne" @click="goPhone(item.telephone)">{{item.telephone}}<van-icon name="phone-o" /></span>
                  </div>
                  <div class="itemxx" v-if="item.IDCard">
                    证件号：
                    <span>{{item.IDCard}}</span>
                  </div>
                </div>
              </div>
            </van-collapse-item>
          </div>
        </van-collapse>
				<van-goods-action v-if="order.order_status =='10'">
					<van-goods-action-button type="danger" text="去支付" @click="goZfFun(order)" />
				</van-goods-action>
			</div>
		</cube-page>
		<van-popup v-model="txshow" round>
			<div class="qrshow">
				<div class="titlebox">
					<p class="title">修改价格</p>
					<p class="right" @click="txshow=false">
						<van-icon name="close" />
					</p>
				</div>
				<van-form @submit="onSubmitTx">
					<!-- 允许输入正整数，调起纯数字键盘 -->
					<van-field v-model="xgprice" name="number" type="number" label="修改价格￥" :colon="true"
						placeholder="请输入修改价格" />
					<div style="margin: 16px;">
						<van-button round block type="info" native-type="submit">提交</van-button>
					</div>
				</van-form>
			</div>
		</van-popup>
		<van-popup v-model="qrshow" round class="qrpopup" style="width: 80%;padding: 40px 0;">
			<div class="qrshow">
				<div class="imgcenter">
					<van-image :src="resData.code_url" alt="二维码" />
				</div>
				<p class="pm"><span>{{resData.code}}</span></p>
			</div>
		</van-popup>
		<SelectZf ref="selectZf" />
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import SelectZf from '../NewPages/selectzf.vue'
	import {
		Dialog,
		Toast
	} from 'vant';

	export default {
		components: {
			CubePage,
			SelectZf
		},
		data() {
			return {
				store: null,
				activeNames: ['1'],
				active: 0,
				txshow: false,
				xgprice: '',
				id: this.$route.query.id,
				isUpdate: this.$route.query.update,
				isShop: this.$route.query.isshop,
				list: {},
			        order: {},
			        remarks: {},
				goods: {},
				detail: {
					address: {
						Area: {}
					},
				},
				disabled: false,
				gcfg: [],
				qrshow: false,
				resData: {}
			};
		},
		created() {
			this.gcfg = this.$store.getters.getGcfg
			this.store = this.$store.getters.getShop
			this.getData()
		},
		methods: {
			goZfFun( item) { 
				this.$refs.selectZf.refOnShow(item,'1');
			}, 
			//退款
			gotk(item) {
				Dialog.confirm({
						title: '温馨提示',
						message: '确认要退款操作吗？'
					}).then(() => {
						this.beforeClose(item);
					})
					.catch(() => {
						// on cancel
					});;
			},
			beforeClose(item) {
				let that = this;
				var url = "/addons/litestore/api.order/refund"
				let param = {
					id: item.id,
					amount: item.pay_price
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						Dialog.alert({
							title: '温馨提示',
							message: result.msg
						}).then(() => {
							that.OrderList = []
							that.pageIndex = 1
							that.pageTotal = 0
							that.get_my_order(that.active)
						});
					},
				);
			},
		 
			//获取核销码
			showQr(item) {
				let that = this;
				var url = "/addons/litestore/api.order/order_wirteoffcode"
				//这里直接调用网络接口
				util.post(url, {
						order_id: that.list.id,
						id: item.id
					},
					function(res) {
						that.resData = res.data
						that.qrshow = true
					},
				);
			},
			onTxshow() {
				this.txshow = true
				this.xgprice = this.list.pay_price
			},
			// 价格修改
			onSubmitTx() {
				var url = "/addons/litestore/api.account/editPayPrice"
				let that = this
				//这里直接调用网络接口
				util.post(url, {
						store_id: that.store.id,
						id: that.id,
						amount: that.xgprice
					},
					function(result) {
						Toast.success(result.msg);
						that.txshow = false
					},
				);
			},
			getData() {
				let that = this
				var url = "/addons/litestore/api.order/detail"
				console.log(that.isUpdate)
				// if (that.isUpdate != undefined) {
				// 	url = "/addons/litestore/api.account/accountDetail"
				// }
				var parm = {
					id: that.id,
					goBack: 'true',
					type: 'scan'
				}
				if (that.isShop != undefined) {
					//util.isToken
					parm = {
						store_id: that.store.id,
						id: that.id,
						type: 'scan'
					}
				}
				//这里直接调用网络接口
				util.get(url, parm,
					function(result) {
						console.log(result)
				            that.order = result.data
				            that.remarks = result.data.remarks
				            that.list = result.data.goods
				            that.xgprice = result.data.pay_price
					},
					function(err) {
						console.log(err)
					}
				);

			},
			decimalPoint(val) {
				const splitPrice = (val || '0.00').split('.');
				const numb1 = splitPrice[0];
				var numb2 = '00';
				if (splitPrice.length > 1) {
					numb2 = splitPrice[1];
				}
				return `${numb1}.<span style="font-size: 12px; line-height: 12px;">${numb2}</span>`;
			}
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			"$store.state.shop"() {
				this.store = this.$store.getters.getShop
			}
		},
	}
</script>
<style lang="less" scoped="scoped">
	@import url("../../assets/css/order.css");
	@import url("../../assets/css/listboxless.less");
  .ordemain {
    padding: 15px;

    .orderfooter {
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;

      .ordernum {}

      .orderjj {
        display: flex;
      }

      .item {
        padding-left: 15px;
        color: #aaabaf;

        .price {
          font-size: 15px;
          font-weight: 600;
        }
      }

      .blodspan {
        color: #000;
        font-weight: 600;
      }
    }
  }

  .ordecontent {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .order {
      flex: 1;
      width: 0;
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .orderright {
        flex: 1;
        width: 0;
        flex-shrink: 0;
        padding: 0 10px;

        .ordername {
          font-size: 14px;
        }

        .orderdec {
          padding: 5px 0;
          font-size: 13px;
        }

        .carddesc {
          font-size: 12px;
        }

        .orderp {
          height: 28px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .ordernum {
            font-size: 12px;
            color: #969799;
          }

          .dj {
            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

	.van-cell {
		background-color: #FFFFFF;
	}

	.van-collapse {
		padding-bottom: 80px;
	}

	.itembox {
		display: flex;
		align-items: center;
		padding: 5px 0;

		.itemleft {
			width: 60px;
		}

		.itemright {
			flex: 1;

			.itemxx {
				line-height: 25px;
			}
		}

		.itembtns {
			width: 78px;
		}
	}

	.itembox+.itembox {
		border-top: 1px solid #e5e5e5;
	}
</style>
